import { ProductSubTier } from '@sparemin/api-sdk';

// default set of tiers that are considered as free
export const DEFAULT_BLACKLIST = [ProductSubTier.FREE];

// set of teirs that are considered free for automation
export const AUTOMATION_BLACKLIST = [
  ProductSubTier.FREE,
  ProductSubTier.EDUCATION_NONPROFIT,
];
